import React from "react";
import styled from "styled-components";
import ClaroImage from "../../molecules/ClaroImage";
import ClaroParagraph from "../../atoms/ClaroParagraph";
import { SERVICE_ID_TELCEL_PAQUETES_POSPAGO, SERVICE_ID_TELCEL_PLANES } from "../../../constants";

const Container = styled.div`
  width: 100%;
`;

const TitlePlans = styled.p`
  font-size: 14px !important;
  margin: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner
      ? "30px 0px 18px 0px"
      : "2% 0em 2% 0em"};
  padding: 0em 0em 0em 0em;
  font-family: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner
      ? "AMX-Bold"
      : "RobotoBold"};
  color: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner ? "#222222" : "#50626c"};
  text-align: center;
  font-weight: normal;
  font-style: normal;
`;

const SubTitlePlans = styled.p`
  font-size: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner
      ? "14px"
      : "16px!important"};
  margin: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner
      ? "0px auto 25px auto"
      : "2% 10% 0em 10%"};
  padding: ${props => props.isContainerTelcel && !props.isClaroPartner 
    ? "0px 37px" 
    : "0em 0em 0em 0em"};
  font-family: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner
      ? "AMX-Regular"
      : "Roboto"};
  color: ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner ? "#222222" : "#50626c"};
  text-align: center;
  font-weight: normal;
  font-style: normal;
  ${(props) =>
    props.isContainerTelcel && !props.isClaroPartner ? `line-height: 22px` : ""}
`;

const HeaderPlans = ({
  dataConfigLogo,
  titlePlans,
  subtitlePlans,
  isContainerTelcel,
  isClaroPartner,
  idService,
  planId,
  isLoadingGetPlans,
}) => {
  let titleImageStyle = {
    align: "center",
    weight: "bold",
    margin: "15px 0px 0px 10px",
  };
  if (isLoadingGetPlans) return null;
  return (
    <Container>
      <TitlePlans
        isContainerTelcel={isContainerTelcel}
        isClaroPartner={isClaroPartner}
        {...titleImageStyle}
      >
        {titlePlans}
      </TitlePlans>
      {
        isContainerTelcel && 
        (
          idService == SERVICE_ID_TELCEL_PLANES ||
          idService == SERVICE_ID_TELCEL_PAQUETES_POSPAGO
        ) ? null : (
          <ClaroImage {...dataConfigLogo} />
        )
      }
      <SubTitlePlans
        isContainerTelcel={isContainerTelcel}
        isClaroPartner={isClaroPartner}
      >
        {subtitlePlans}
      </SubTitlePlans>
    </Container>
  );
};

export default HeaderPlans;
